import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import UnfilledAppliedCandidateForContractModal from "@/Components/common/client/contracts/Unfilled/UnfilledAppliedCandidateForContractModal";
import UnfilledList from "@/Components/common/client/contracts/Unfilled/UnfilledList";
import { updateactivePages } from "@/reducers/clientcommon";
import {
  fetchUnfilledContracts,
  setUnfilledContractsLoading,
  updatePagination,
  deSelectAllContract,
} from "@/reducers/clientunfilledcontracts";

import { CandidateTypes } from "../../../Components/common/client/candidates/CandidateTypes";
import useTitle from "../../../utilities/hooks/useTitle";

const Unfilled = () => {
  useTitle("Unfilled Contracts");
  const { filters, pagination } = useSelector(
    (state) => state.clientUnfilledContracts,
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setUnfilledContractsLoading(true));
    dispatch(deSelectAllContract());
    dispatch(fetchUnfilledContracts(filters));
    dispatch(
      updateactivePages({
        activePage: "schedule",
        activeSubPage: "unfilled",
      }),
    );
    // dispatch(fetchClientPublishBankContract());
  }, []);
  return (
    <div className="flex flex-col gap-4">
      <CandidateTypes />
      <UnfilledList />
      {/* <ProposeCandidateShiftsCalendar /> */}
      <UnfilledAppliedCandidateForContractModal />
    </div>
  );
};

export default Unfilled;
